export const getImportSourceFilterStyle = () => ({
  importSourceFilterDowndown: {
    padding: 24,
    pointerEvents: 'auto',

    '& .dropdown-title': {
      fontSize: 20,
      fontWeight: 600,
      lineHeight: '20px',
    },

    '& .dropdown-import-source-choices label': {
      fontSize: 14,
      fontWeight: 400,
      padding: 0,
      marginTop: 8,
    },
  },
});
